import React, { useEffect } from "react";
import { Box, Container, Link, Paper, Stack, Typography } from "@mui/material";
import { Link as RouterLink, useLocation } from "react-router-dom";
import ReactMarkdown from "react-markdown";
import { timelyPrivacy, timelyTerms, timelyInfoPages } from "./timelyLegalContent";
import ContactUsForm from "../business/contactUsForm";

export default function TimelyLegalPage() {
  const { pathname } = useLocation();
  const isPrivacy = pathname === "/privacy";
  const page = pathname === "/privacy"
    ? { title: "Privacy Policy", content: timelyPrivacy }
    : pathname === "/terms"
      ? { title: "Terms of Service", content: timelyTerms }
      : timelyInfoPages[pathname] || timelyInfoPages["/about"];

  useEffect(() => {
    const previousTitle = document.title;
    document.title = `${page.title} | Timely365`;
    return () => { document.title = previousTitle; };
  }, [page.title]);

  return (
    <Box component="main" sx={{ bgcolor: "background.default", color: "text.primary", colorScheme: theme => theme.palette.mode, py: { xs: 3, md: 6 }, minHeight: "100vh" }}>
      <Container maxWidth="md">
        <Stack component="nav" aria-label="Legal pages" direction="row" spacing={3} sx={{ mb: 3, flexWrap: "wrap", rowGap: 1 }}>
          <Link component={RouterLink} to="/" sx={{ fontWeight: 800, display: "inline-flex", alignItems: "center", gap: 1 }}>
            <Box component="img" src="/images/timely365-icon.png" alt="" sx={{ width: 32, height: 32, transform: "scale(1.8)" }} />
            Timely365
          </Link>
          <Link component={RouterLink} to="/privacy" aria-current={isPrivacy ? "page" : undefined}>Privacy Policy</Link>
          <Link component={RouterLink} to="/terms" aria-current={pathname === "/terms" ? "page" : undefined}>Terms of Service</Link>
          <Link component={RouterLink} to="/security" aria-current={pathname === "/security" ? "page" : undefined}>Security</Link>
          <Link component={RouterLink} to="/contact">Contact</Link>
        </Stack>
        <Paper component="article" elevation={0} sx={{
          p: { xs: 2.5, sm: 5 }, border: "1px solid", borderColor: "divider", borderRadius: 3,
          bgcolor: "background.paper", backgroundImage: "none",
          color: "text.primary", lineHeight: 1.8, overflowWrap: "anywhere",
          "& h1": { fontSize: { xs: "1.8rem", sm: "2.4rem" }, lineHeight: 1.2, color: "text.primary", mt: 0 },
          "& h2": { fontSize: "1.25rem", lineHeight: 1.4, mt: 4, color: "text.primary" },
          "& a": { color: "primary.main", textUnderlineOffset: "3px" },
          "& li": { mb: 1 }, "& ul": { pl: 3 },
        }}>
          {pathname === "/contact" ? <>
            <Typography component="h1">Contact Timely365</Typography>
            <Typography sx={{ mb: 3 }}>Send a support question, privacy request, or account deletion request to our team.</Typography>
            <ContactUsForm showHeading={false} />
          </> : <ReactMarkdown>{page.content}</ReactMarkdown>}
        </Paper>
      </Container>
    </Box>
  );
}
